"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var user_status_1 = __importDefault(require("./user.status"));
var activity_types_1 = require("./activity.types");
var PRIVATE = 'private';
var ACTIVITY = 'activity';
var STAFF = 'staff';
var NON_STATUS_CHANGE_MODIFIER = 'none';
var CATEGORIES = {
    PRIVATE: PRIVATE,
    ACTIVITY: ACTIVITY,
    MEAL: activity_types_1.MEAL,
    STAFF: STAFF,
};
var SPECIAL_TIMES = {
    none: 'none',
    allDay: 'allDay',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
};
var UPDATE_ACTION;
(function (UPDATE_ACTION) {
    UPDATE_ACTION["add"] = "add";
    UPDATE_ACTION["remove"] = "remove";
})(UPDATE_ACTION || (UPDATE_ACTION = {}));
var ACTIVITY_FIELDS;
(function (ACTIVITY_FIELDS) {
    ACTIVITY_FIELDS["attended"] = "attended";
    ACTIVITY_FIELDS["type"] = "type";
    ACTIVITY_FIELDS["name"] = "name";
    ACTIVITY_FIELDS["calendar"] = "calendar";
    ACTIVITY_FIELDS["calendars"] = "calendars";
    ACTIVITY_FIELDS["startDate"] = "startDate";
    ACTIVITY_FIELDS["startTime"] = "startTime";
    ACTIVITY_FIELDS["endDate"] = "endDate";
    ACTIVITY_FIELDS["endTime"] = "endTime";
    ACTIVITY_FIELDS["special"] = "special";
    ACTIVITY_FIELDS["location"] = "location";
    ACTIVITY_FIELDS["description"] = "description";
    ACTIVITY_FIELDS["staffAssigned"] = "staffAssigned";
    ACTIVITY_FIELDS["cancelledAt"] = "cancelledAt";
    ACTIVITY_FIELDS["timeSlot"] = "timeSlot";
    ACTIVITY_FIELDS["allowConnections"] = "allowConnections";
    ACTIVITY_FIELDS["instanceCheck"] = "instanceCheck";
    ACTIVITY_FIELDS["maxRegistered"] = "maxRegistered";
    ACTIVITY_FIELDS["maxRegisteredConnections"] = "maxRegisteredConnections";
    ACTIVITY_FIELDS["modified"] = "modified";
    ACTIVITY_FIELDS["recurring"] = "recurring";
    ACTIVITY_FIELDS["declined"] = "declined";
    ACTIVITY_FIELDS["registrations"] = "registrations";
    ACTIVITY_FIELDS["connectionRegistrations"] = "connectionRegistrations";
    ACTIVITY_FIELDS["connectionRegistrationData"] = "connectionRegistrationData";
    ACTIVITY_FIELDS["recurringId"] = "recurringId";
    ACTIVITY_FIELDS["modifier"] = "modifier";
    ACTIVITY_FIELDS["deletedAt"] = "deletedAt";
    ACTIVITY_FIELDS["attendedReasons"] = "attendedReasons";
    ACTIVITY_FIELDS["declineReasons"] = "declineReasons";
    ACTIVITY_FIELDS["ratings"] = "ratings";
    ACTIVITY_FIELDS["attachments"] = "attachments";
    ACTIVITY_FIELDS["facilitatorNotes"] = "facilitatorNotes";
    ACTIVITY_FIELDS["aiAssistanceModel"] = "aiAssistanceModel";
    ACTIVITY_FIELDS["transactionId"] = "transactionId";
    ACTIVITY_FIELDS["history"] = "history";
})(ACTIVITY_FIELDS || (ACTIVITY_FIELDS = {}));
var NO_UPDATES = [];
var ATTENDANCE_FIELDS = [
    ACTIVITY_FIELDS.attended,
    ACTIVITY_FIELDS.attendedReasons,
    ACTIVITY_FIELDS.connectionRegistrations,
    ACTIVITY_FIELDS.connectionRegistrationData,
    ACTIVITY_FIELDS.declined,
    ACTIVITY_FIELDS.declineReasons,
    ACTIVITY_FIELDS.ratings,
    ACTIVITY_FIELDS.registrations,
];
var STAFF_MINIMUM_UPDATE = __spreadArray(__spreadArray([], ATTENDANCE_FIELDS, true), [
    'recurring',
    'modified',
    ACTIVITY_FIELDS.history,
], false);
var EXPOSED_UPDATE = __spreadArray(__spreadArray([], STAFF_MINIMUM_UPDATE, true), [
    ACTIVITY_FIELDS.staffAssigned,
    ACTIVITY_FIELDS.cancelledAt,
    ACTIVITY_FIELDS.timeSlot,
    ACTIVITY_FIELDS.allowConnections,
    ACTIVITY_FIELDS.description,
    ACTIVITY_FIELDS.endDate,
    ACTIVITY_FIELDS.endTime,
    ACTIVITY_FIELDS.instanceCheck,
    ACTIVITY_FIELDS.location,
    ACTIVITY_FIELDS.maxRegistered,
    ACTIVITY_FIELDS.maxRegisteredConnections,
    ACTIVITY_FIELDS.modified,
    ACTIVITY_FIELDS.name,
    ACTIVITY_FIELDS.recurring,
    ACTIVITY_FIELDS.special,
    ACTIVITY_FIELDS.startDate,
    ACTIVITY_FIELDS.startTime,
    ACTIVITY_FIELDS.type,
    ACTIVITY_FIELDS.attachments,
    ACTIVITY_FIELDS.facilitatorNotes,
    ACTIVITY_FIELDS.history,
], false);
var EXPOSED_CREATE = __spreadArray(__spreadArray([], EXPOSED_UPDATE, true), [
    ACTIVITY_FIELDS.calendar,
    ACTIVITY_FIELDS.calendars,
    ACTIVITY_FIELDS.modifier,
    ACTIVITY_FIELDS.recurringId,
    ACTIVITY_FIELDS.facilitatorNotes,
    ACTIVITY_FIELDS.aiAssistanceModel,
    ACTIVITY_FIELDS.transactionId,
    ACTIVITY_FIELDS.history,
], false);
var COPY_FIELDS = [
    ACTIVITY_FIELDS.type,
    ACTIVITY_FIELDS.name,
    ACTIVITY_FIELDS.startDate,
    ACTIVITY_FIELDS.startTime,
    ACTIVITY_FIELDS.endDate,
    ACTIVITY_FIELDS.endTime,
    ACTIVITY_FIELDS.special,
    ACTIVITY_FIELDS.location,
    ACTIVITY_FIELDS.description,
    ACTIVITY_FIELDS.staffAssigned,
    ACTIVITY_FIELDS.recurringId,
    ACTIVITY_FIELDS.recurring,
    ACTIVITY_FIELDS.modifier,
    ACTIVITY_FIELDS.maxRegistered,
    ACTIVITY_FIELDS.maxRegisteredConnections,
    ACTIVITY_FIELDS.allowConnections,
    ACTIVITY_FIELDS.deletedAt,
    ACTIVITY_FIELDS.cancelledAt,
    ACTIVITY_FIELDS.timeSlot,
    ACTIVITY_FIELDS.facilitatorNotes,
    ACTIVITY_FIELDS.aiAssistanceModel,
    ACTIVITY_FIELDS.transactionId,
];
var MODIFIERS = {
    startLeave: {
        key: 'startLeave',
        label: 'Begin Leave of Absence',
        activityName: 'Started Leave of Absence',
        userStatus: user_status_1.default.onLeave,
    },
    returnFromLeave: {
        key: 'returnFromLeave',
        label: 'Return from Leave of Absence',
        activityName: 'Return from Leave of Absence',
        userStatus: user_status_1.default.active,
    },
    active: {
        key: 'active',
        label: 'Re-activate this resident',
        activityName: 'Status changed to Active',
        userStatus: user_status_1.default.active,
    },
    inactive: {
        key: 'inactive',
        label: 'Deactivate this resident',
        activityName: 'Status changed to Deactivated',
        userStatus: user_status_1.default.inactive,
    },
};
var REGISTRATION_TYPES = {
    OPEN: { label: 'Open', value: 'OPEN' },
    TIME_SLOTS: { label: 'Time Slots', value: 'TIME_SLOTS' },
    DISABLED: { label: 'Disabled', value: 'NONE' },
};
var FEED_FILTERS = {
    activity: {
        value: 'activity',
        label: 'Activity',
        filter: function (activity) {
            return activity.modifier === 'none' &&
                activity.type !== activity_types_1.SNACK &&
                activity.type !== activity_types_1.MEAL &&
                activity.type !== activity_types_1.DINING_MEAL_USER_EVENT;
        },
    },
    meal: {
        value: 'meal',
        label: 'Meal',
        filter: function (activity) {
            return activity.type === activity_types_1.MEAL ||
                activity.type === activity_types_1.DINING_MEAL_USER_EVENT ||
                activity.type === activity_types_1.SNACK;
        },
    },
    personal: {
        value: 'personal',
        label: 'Personal',
        filter: function (activity) {
            return activity.type === activity_types_1.PERSONAL && activity.modifier === 'none';
        },
    },
    statusChange: {
        value: 'statusChange',
        label: 'Status Change',
        filter: function (activity) { return activity.modifier !== 'none'; },
    },
};
var SORT_OPTIONS = [
    { value: 'firstName', label: 'First Name', direction: 'asc' },
    { value: 'firstName', label: 'First Name', direction: 'desc' },
    { value: 'lastName', label: 'Last Name', direction: 'asc' },
    { value: 'lastName', label: 'Last Name', direction: 'desc' },
    { value: 'nickname', label: 'Preferred Name', direction: 'asc' },
    { value: 'nickname', label: 'Preferred Name', direction: 'desc' },
];
var ACTIVITY_ATTACHMENT_OPTIONS = {
    ONLY_THIS_ACTIVITY: {
        value: 'ONLY_THIS_ACTIVITY',
        label: 'Only this Activity',
        helpText: 'All other activities in the series will remain the same.',
    },
    ALL_ACTIVITIES: {
        value: 'ALL_ACTIVITIES',
        label: 'All Activities',
        helpText: 'All activities in the series will be edited.',
    },
};
// Fields persisted on history field to track changes on activity
var HISTORY_FIELDS = [
    ACTIVITY_FIELDS.name,
    ACTIVITY_FIELDS.description,
    ACTIVITY_FIELDS.type,
    ACTIVITY_FIELDS.facilitatorNotes,
];
module.exports = {
    ACTIVITY_ATTACHMENT_OPTIONS: ACTIVITY_ATTACHMENT_OPTIONS,
    NO_UPDATES: NO_UPDATES,
    CATEGORIES: CATEGORIES,
    COPY_FIELDS: COPY_FIELDS,
    SPECIAL_TIMES: SPECIAL_TIMES,
    EXPOSED_CREATE: EXPOSED_CREATE,
    EXPOSED_UPDATE: EXPOSED_UPDATE,
    STAFF_MINIMUM_UPDATE: STAFF_MINIMUM_UPDATE,
    ATTENDANCE_FIELDS: ATTENDANCE_FIELDS,
    MODIFIERS: MODIFIERS,
    REGISTRATION_TYPES: REGISTRATION_TYPES,
    FEED_FILTERS: FEED_FILTERS,
    MEAL: activity_types_1.MEAL,
    DINING_MEAL_USER_EVENT: activity_types_1.DINING_MEAL_USER_EVENT,
    SNACK: activity_types_1.SNACK,
    PERSONAL: activity_types_1.PERSONAL,
    NON_STATUS_CHANGE_MODIFIER: NON_STATUS_CHANGE_MODIFIER,
    SORT_OPTIONS: SORT_OPTIONS,
    UPDATE_ACTION: UPDATE_ACTION,
    ACTIVITY_FIELDS: ACTIVITY_FIELDS,
    HISTORY_FIELDS: HISTORY_FIELDS,
};
